import { render, staticRenderFns } from "./RoleWeightingFilters.vue?vue&type=template&id=ecea06d4&scoped=true"
import script from "./RoleWeightingFilters.vue?vue&type=script&lang=js"
export * from "./RoleWeightingFilters.vue?vue&type=script&lang=js"
import style0 from "./RoleWeightingFilters.vue?vue&type=style&index=0&id=ecea06d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecea06d4",
  null
  
)

export default component.exports